import React from "react"
import {FieldQuickFilterViewProps} from "../../../render/quick-filter-view"

import PriorityIcon from "../../../../gd-components/priority/priority-icon/priority-icon"
import {BREAKDOWN_ALL_VALUES} from "../../../../gd-modules/tasks-view/core/@const"

export default function FieldPriority_QuickFilterView(props: FieldQuickFilterViewProps) {

    let priority : any = parseInt(props.value)
    if (!priority) priority = null

    let icon = null
    let label = ''

    switch (props.value) {
        case BREAKDOWN_ALL_VALUES:
            label = 'All priorities'
            break

        default:
            icon = <PriorityIcon className="group-icon" priority={priority}/>
            label = gd.company.priorities.getName(priority,true)
            break

    }

    const classes = Classes("ui5-group-by-view", props.className)

    return (
        <div className={classes}>
            {icon}
            <div className="name">{label}</div>
        </div>
    )

}